/**
 * PÁGINA DE PRECIOS
 * ==================
 * Esta página mostrará información detallada sobre precios:
 * - Cotizaciones actuales de ganado
 * - Histórico de precios
 * - Gráficos y tendencias
 * - Comparativas entre categorías
 * - Reportes de mercado
 * 
 * ESTADO ACTUAL: Página en construcción
 */

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { DollarSign, BarChart3, TrendingUp, ArrowLeft } from 'lucide-react';

const PreciosPage = () => {
  const navigate = useNavigate();
  return (
    // Contenedor principal
    <div className="min-h-screen bg-gray-50 pt-24">

      <div className="max-w-7xl mx-auto px-4 py-12">

        <div className="bg-white rounded-2xl shadow-xl p-12 text-center">

          {/* Icono de precios */}
          <div className="flex justify-center mb-6">
            <div className="bg-emerald-100 rounded-full p-6">
              <DollarSign className="w-16 h-16 text-emerald-600" />
            </div>
          </div>

          {/* Título */}
          <h1 className="text-4xl font-bold text-gray-900 mb-4">
            Monitor de Precios
          </h1>

          <p className="text-xl text-gray-600 mb-8 max-w-2xl mx-auto">
            Accede a las cotizaciones más recientes y análisis de mercado detallados.
          </p>

          {/* Características futuras */}
          <div className="grid md:grid-cols-3 gap-6 mt-12">

            <div className="bg-gray-50 rounded-xl p-6">
              <DollarSign className="w-12 h-12 text-emerald-600 mx-auto mb-4" />
              <h3 className="font-bold text-lg mb-2">Cotizaciones en Vivo</h3>
              <p className="text-gray-600 text-sm">
                Precios actualizados por categoría de ganado
              </p>
            </div>

            <div className="bg-gray-50 rounded-xl p-6">
              <BarChart3 className="w-12 h-12 text-emerald-600 mx-auto mb-4" />
              <h3 className="font-bold text-lg mb-2">Gráficos Históricos</h3>
              <p className="text-gray-600 text-sm">
                Visualiza la evolución de precios en el tiempo
              </p>
            </div>

            <div className="bg-gray-50 rounded-xl p-6">
              <TrendingUp className="w-12 h-12 text-emerald-600 mx-auto mb-4" />
              <h3 className="font-bold text-lg mb-2">Análisis de Mercado</h3>
              <p className="text-gray-600 text-sm">
                Reportes y tendencias del mercado ganadero
              </p>
            </div>
          </div>

          {/* Estado de construcción */}
          <div className="mt-12 bg-blue-50 border border-blue-200 rounded-lg p-4">
            <p className="text-blue-800 font-medium">
              🚧 Esta sección está en construcción y será implementada próximamente
            </p>
          </div>

          {/* Botón Volver */}
          <div className="mt-8">
            <button
              onClick={() => navigate('/')}
              className="inline-flex items-center gap-2 px-6 py-3 bg-gray-900 text-white rounded-lg hover:bg-gray-800 transition-colors font-medium"
            >
              <ArrowLeft className="w-5 h-5" />
              Volver al inicio
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PreciosPage;